import { createContext } from 'react';

// Створюємо контекст, за замовченням пустий, ініціалізуємо його як null
export const AuthContext = createContext(null);
